import { Modal, Radio } from "antd";
import Button, { ButtonProps } from "Components/Button";
import { useState } from "react";
import { SearchBox } from "../SearchBox";
import { useDebounce } from "hooks/useDebounce";
import Loader from "Components/Loader";
import { cn } from "utils";
import {
  Branch,
  useGetBranchesQuery,
} from "hooks/BranchManagement/useGetBranchesQuery";

type ManualOrderBranchSelectionProps = {
  isOpen: boolean;
  onClose: () => void;
  branch: Branch | null;
  setBranch: (customer: Branch | null) => void;
  confirmButtonProps: Partial<ButtonProps>;
};

export const ManualOrderBranchSelection = ({
  branch: currentBranch,
  setBranch,
  onClose,
  isOpen,
  confirmButtonProps = {},
}: ManualOrderBranchSelectionProps) => {
  const [branchSearch, setBranchSearch] = useState("");

  const debouncedSearch = useDebounce(branchSearch);

  const { data, isPending } = useGetBranchesQuery({
    search: debouncedSearch,
  });

  const branches = data?.data.docs || [];

  const getBranchById = (id: string) => {
    return branches.find((branch) => branch.id === id) || null;
  };

  const onModalClose = (clearCustomer = false) => {
    onClose();
    if (clearCustomer) {
      setBranch(null);
    }
  };

  return (
    <div>
      <Modal
        title="Select Branch"
        open={isOpen}
        className="max-w-[40rem] !w-full"
        onCancel={() => onClose()}
        footer={
          <div className="flex justify-between gap-4">
            <Button
              className={`bg-[#F4F4F4] text-black`}
              label={"Cancel"}
              onClick={() => onModalClose()}
            />
            <Button
              {...confirmButtonProps}
              className={cn(
                `text-white p-[12px] w-full font-bold rounded-md ease-in-out duration-300`,
                confirmButtonProps.className
              )}
              label={confirmButtonProps.label || "Continue"}
              disabled={!currentBranch}
              onClick={confirmButtonProps.onClick}
            />
          </div>
        }>
        <div className="w-full">
          <div className="w-full flex">
            <SearchBox
              value={branchSearch}
              onChange={setBranchSearch}
              placeholder="Search Name, ID, Email Address"
              className="rounded-xl bg-[#F3F3F3] w-full"
            />
          </div>

          {isPending && <Loader />}

          {/* list */}
          <Radio.Group
            value={currentBranch?.id}
            onChange={(e) => setBranch(getBranchById(e.target.value))}
            className="w-full"
            name="customer">
            <div className="max-h-[70vh] overflow-y-auto py-4 w-full">
              {branches.map((branch) => (
                <Radio
                  key={branch.id}
                  value={branch.id}
                  className={cn(
                    "flex items-center space-x-3 border-b border-border px-4 py-3",
                    branch.id === currentBranch?.id ? "bg-primary-light" : ""
                  )}>
                  <div className="flex items-center space-x-3">
                    {/* User Details */}
                    <div className="space-y-1">
                      <h3 className="text-sm font-medium">{branch.name}</h3>
                      <p className="text-sm text-gray-500 font-normal">
                        {branch.address} {branch.state}
                      </p>
                      <p className="text-sm text-gray-500 font-normal">
                        Code: #{branch.code}
                      </p>
                    </div>
                  </div>
                </Radio>
              ))}
            </div>
          </Radio.Group>
        </div>
      </Modal>
    </div>
  );
};
